var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("common.security.title") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "4", lg: "2", xl: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter",
                        attrs: { disabled: _vm.activateSpinner },
                        on: {
                          click: function ($event) {
                            return _vm.onRefresh()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-rotate-right fs-14px",
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.rfrsh")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "text-xl-center mb-5",
                    attrs: { cols: "9", lg: "8", xl: "6" },
                  },
                  [
                    _c(
                      "b-button-group",
                      { staticClass: "mt-3 mt-sm-0" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant:
                                _vm.tabName === 0 ? "primary btn-selected" : "",
                            },
                            on: {
                              click: function ($event) {
                                _vm.tabName = 0
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("common.security.trust_store"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant:
                                _vm.tabName === 1 ? "primary btn-selected" : "",
                            },
                            on: {
                              click: function ($event) {
                                _vm.tabName = 1
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.security.key_store")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "6", lg: "4", xl: "4" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "secondary", disabled: !_vm.canAdd },
                        on: { click: _vm.addP12 },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(" "),
                        _vm.tabName === 0
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("common.security.add_p12", {
                                    itemLabel: "truststore",
                                  })
                                )
                              ),
                            ])
                          : _vm.tabName === 1
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("common.security.add_p12", {
                                    itemLabel: "keystore",
                                  })
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "6", lg: "4", xl: "4" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "secondary", disabled: !_vm.canAdd },
                        on: { click: _vm.addPEM },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(" "),
                        _vm.tabName === 0
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("common.security.add_pem", {
                                    itemLabel: "truststore",
                                  })
                                )
                              ),
                            ])
                          : _vm.tabName === 1
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("common.security.add_pem", {
                                    itemLabel: "keystore",
                                  })
                                )
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tabs",
              {
                attrs: { "nav-class": "d-none" },
                model: {
                  value: _vm.tabName,
                  callback: function ($$v) {
                    _vm.tabName = $$v
                  },
                  expression: "tabName",
                },
              },
              [
                _vm.canSeeCA
                  ? _c(
                      "b-tab",
                      { attrs: { title: _vm.$t("common.security.ca") } },
                      [
                        _c("security-list", {
                          key: _vm.refreshKey,
                          attrs: {
                            typeList: "ca",
                            spinnerActivated: _vm.activateSpinner,
                          },
                          model: {
                            value: _vm.tabValue,
                            callback: function ($$v) {
                              _vm.tabValue = $$v
                            },
                            expression: "tabValue",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canSeeKeyStore
                  ? _c(
                      "b-tab",
                      { attrs: { title: _vm.$t("common.security.keystore") } },
                      [
                        _c("security-list", {
                          key: _vm.refreshKey,
                          attrs: {
                            typeList: "keystore",
                            spinnerActivated: _vm.activateSpinner,
                          },
                          model: {
                            value: _vm.tabValue,
                            callback: function ($$v) {
                              _vm.tabValue = $$v
                            },
                            expression: "tabValue",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }